import { render, staticRenderFns } from "./ConsultantCompanyInfoSave.vue?vue&type=template&id=38230c64"
import script from "./ConsultantCompanyInfoSave.vue?vue&type=script&lang=js"
export * from "./ConsultantCompanyInfoSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports